import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { MessageService } from "../../services/message.service";
import { TurnkeyTrackerService } from "../../services/turnkey-tracker.service";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";

@Component({
  selector: "app-owner",
  templateUrl: "./owner.component.html",
  styleUrls: ["./owner.component.scss"],
})
export class OwnerComponent implements OnInit, OnChanges {

  @ViewChild('userInput') userInput:ElementRef<HTMLButtonElement>;
  @Input() filterOwner: boolean = false;
  @Input() inputString: any;
  @Input() inputType: any;
  @Output() refereshParentData = new EventEmitter<string>();
  @Input() editable = true;
  @Input() ownerdata: any;
  @Input() context: any = "";
  @Input() allowOneInput = false;
  @Input() label : string;
  @Input() required : boolean = false;
  @Input() moduleName?: string;

  oldData: any;
  owners: any;
  selectedOwners: any = [];

  myControl = new FormControl();
  filteredOptions: Observable<string[]>;

  editMode = false;

  constructor(
    private readonly cookieService: CookieService,
    private readonly messageService: MessageService,
    private readonly turnkeyTrackerService: TurnkeyTrackerService
  ) {}

  ngOnInit() {
    if (!this.filterOwner) {
      this.getOwner();
      if (!this.cookieService.get("owner")) {
        const myDate: Date = new Date();
        myDate.setSeconds(myDate.getSeconds() + 10);
        this.cookieService.set("owner", "true", { expires: myDate });
        this.getAllOwner();
      }
    } else if (this.filterOwner) {
      this.getFilterOwner();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  getOwerNamesList() {
    let names = this.selectedOwners.map((user: any) => {
      return user?.first_name + " " + user?.last_name;
    });
    return names.join(", ");
  }

  focusInput() {
    setTimeout(() => this.userInput.nativeElement.focus(), 0);
  }

  setOwnerData(owners: any) {
    this.selectedOwners = [];
    this.owners = owners;
    if (this.ownerdata) {
      this.ownerdata.forEach((element: any) => {
        this.owners.forEach((elm: any) => {
          if (elm.id === element?.user || elm.id === element) {
            this.selectedOwners.push(elm);
          }
        });
      });
    }
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );
  }

  getFilterOwner() {
    const params: any = {};
    if (this.moduleName) {
      params.users = this.moduleName;
    }
    this.turnkeyTrackerService
      .getFilterOwner(params)
      .subscribe((res: any) => {
        this.setOwnerData(res);
      });
  }

  async getOwner() {
    this.messageService.getOwner().subscribe((res: any) => {
      if (res.length > 0) {
        this.setOwnerData(res);
      }
    });
  }

  private _filter(value: any): any {
    if (typeof value === "string") {
      const filterValue = value.toLowerCase();
      const removeSelected = this.owners.filter(
        (el: any) => !this.selectedOwners.includes(el)
      );
      return removeSelected.filter((owner: any) => {
        const firstName = owner?.first_name?.toLowerCase() || '';
        const lastName = owner?.last_name?.toLowerCase() || '';
        const fullName = `${firstName} ${lastName}`.trim();
        return fullName.includes(filterValue);
      });
    }
    return null;
  }

  getAllOwner() {
    this.turnkeyTrackerService.getOwner().subscribe((res: any) => {
      this.messageService.setOwner(res);
    });
  }

  addOwner(e: any) {
    if (this.allowOneInput) {
      if (this.selectedOwners.length === 0) {
        this.selectedOwners.push(e);
        this.myControl.setValue("");
        this.sendToParent();
      } else {
        this.myControl.setValue("");
        this.sendToParent();
        return;
      }
    } else {
      this.selectedOwners.push(e);
      this.myControl.setValue("");
      this.sendToParent();
    }
  }

  getIconNameShort(obj: any) {
    let firstName = "";
    let lastName = "";
    if (obj.first_name) {
      firstName = obj.first_name.substring(0, 1);
    }
    if (obj.last_name) {
      lastName = obj.last_name.substring(0, 1);
    }
    return (firstName + lastName).toUpperCase();
  }

  removeUser(i: any) {
    this.selectedOwners.splice(i, 1);
    this.sendToParent();
  }

  sendToParent() {
    const sel: any = [];
    this.selectedOwners.forEach((element: any) => {
      sel.push(element.id);
    });

    this.refereshParentData.emit(sel);
  }

  cancelEdit() {
    this.inputString = this.oldData;
    this.editMode = false;
  }
}
